export default __webpack_public_path__ + "static/media/Tread-Gray.7e443ade.svg";